// extracted by mini-css-extract-plugin
module.exports = {"textarea":"textareaFormProject_textarea__1ztXU"};
    if(module.hot) {
      // 1790670320634
      var cssReload = require("!../../../../../node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);;
    }
  